import { Disclosure as HeadlessDisclosure } from '@headlessui/react'
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline'
import { clsx } from 'clsx'
import { useLayoutVariant } from '../../hooks/useLayoutVariant'

export default function Disclosure({ 
  title, 
  children, 
  defaultOpen = false,
  className = '' 
}) {
  const { isAdminAppUI } = useLayoutVariant()
  return (
    <HeadlessDisclosure defaultOpen={defaultOpen} as="div" className={className}>
      {({ open }) => (
        <>
          <HeadlessDisclosure.Button className={clsx(
            'flex w-full items-center justify-between py-2 px-4 text-left text-sm font-medium',
            isAdminAppUI
              ? 'text-[#e8edf5] hover:bg-[rgba(0,200,150,0.06)] rounded-[10px] transition-colors'
              : 'text-gray-900 dark:text-white hover:bg-gray-50 dark:hover:bg-gray-700 rounded-lg transition-colors'
          )}>
            <span>{title}</span>
            {open ? (
              <ChevronUpIcon className={clsx('h-5 w-5', isAdminAppUI ? 'text-[#7a8fa6]' : 'text-gray-500 dark:text-gray-400')} />
            ) : (
              <ChevronDownIcon className={clsx('h-5 w-5', isAdminAppUI ? 'text-[#7a8fa6]' : 'text-gray-500 dark:text-gray-400')} />
            )}
          </HeadlessDisclosure.Button>
          <HeadlessDisclosure.Panel className={clsx(
            'px-4 pb-4 pt-2 text-sm',
            isAdminAppUI ? 'text-[#7a8fa6]' : 'text-gray-500 dark:text-gray-400'
          )}>
            {children}
          </HeadlessDisclosure.Panel>
        </>
      )}
    </HeadlessDisclosure>
  )
}

